import { jsonata } from './jsonata.validator';
import { max } from './max.validator';
import { min } from './min.validator';
import { pattern } from './pattern.validator';
import { required } from './required.validator';
import { ValidatorFunction } from '../types/validator-function.type';

export const validators = new Map<string, ValidatorFunction>([
  ['min', min],
  ['max', max],
  ['pattern', pattern],
  ['required', required],
  ['jsonata', jsonata],
]);
